// Authenticated file download helper.
// Fetches a file as a blob using the existing Bearer token, keeps the original
// filename from the Content-Disposition header, and triggers a browser save.
// Used for the FileAsset download endpoints (essays, applied-university forms,
// transcripts, internship task submissions).

const BASE = process.env.REACT_APP_BASE_URL_API || ''

export const downloadFileAsset = async ({ path, params = {}, fallbackName = 'download' }) => {
  const token = localStorage.getItem('token')

  const query = new URLSearchParams(
    Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== ''),
  ).toString()
  const url = `${BASE}${path.startsWith('/') ? path : `/${path}`}${query ? `?${query}` : ''}`

  const response = await fetch(url, {
    method: 'GET',
    headers: { Authorization: `Bearer ${token}` },
  })
  if (!response.ok) throw new Error(`Failed to download file: ${response.status}`)

  const blob = await response.blob()
  const disposition = response.headers.get('content-disposition') || ''
  const match = disposition.match(/filename\*?=(?:UTF-8''|"?)([^";]+)/i)
  const fileName = match ? decodeURIComponent(match[1].replace(/"/g, '')) : fallbackName

  const objectUrl = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = objectUrl
  link.download = fileName
  document.body.appendChild(link)
  link.click()
  link.remove()
  window.URL.revokeObjectURL(objectUrl)
  return fileName
}

export default downloadFileAsset
